import {Component, EventEmitter, Input, OnChanges, Output, ViewEncapsulation} from '@angular/core';
import {WidgetCheckboxV0NodeDto} from './models/widget-checkbox-v0-node.dto';
import {WidgetCheckboxV0ChildrenDto} from "./models/widget-checkbox-v0-children.dto";
import {IoniconsFilled} from "@pt/pt-models";

@Component({
  selector: 'pt-widget-checkbox-v0-edit-children',
  template: `
    <div ngbAccordion #accordion="ngbAccordion" [closeOthers]="true">
      <ng-container *ngFor='let parent of copiedCheckBox'>
        <ng-container *ngFor="let c of parent.children">
          <div ngbAccordionItem [collapsed]="true" *ngIf="editMode || c.checked">
            <div ngbAccordionHeader class="accordion-button custom-header justify-content-between">

              <button ngbAccordionButton
                      style="padding: 0 0 0 5px;"
                      *ngIf="hasChildren(c.parentId); else noChildren">
                <div class="form-check w-100" *ngIf="editMode">
                  <input
                    (click)="$event.stopPropagation()"
                    class="form-check-input" type="checkbox"
                    [(ngModel)]="c.checked"
                    (ngModelChange)="checkboxChangeValue($event, c)" id="{{c.uuid}}">
                  <label class="form-check-label" for="{{c.uuid}}" (click)="$event.stopPropagation()">
                    {{ c.label }}
                  </label>
                  <pt-w-help (click)='$event.stopPropagation(); $event.stopImmediatePropagation()'
                                  [help]='c.help'></pt-w-help>
                </div>

                <div class="w-100" *ngIf="!editMode">
                  <pt-icon *ngIf="c.checked" class="widget-icon-preview-color me-1" [key]='IconCheckFilled'></pt-icon>
                  <label class="form-check-label" for="{{c.uuid}}">
                    {{ c.label }}
                  </label>
                  <pt-w-help (click)='$event.stopPropagation(); $event.stopImmediatePropagation()'
                                  [help]='c.help'></pt-w-help>
                </div>
              </button>

              <ng-template #noChildren>
                <div class="form-check w-100" style="margin-left: 5px;" *ngIf="editMode">
                  <input
                    (click)="$event.stopPropagation()"
                    class="form-check-input" type="checkbox"
                    [(ngModel)]="c.checked"
                    (ngModelChange)="checkboxChangeValue($event, c)" id="{{c.uuid}}">
                  <label class="form-check-label" for="{{c.uuid}}" (click)="$event.stopPropagation()">
                    {{ c.label }}
                  </label>
                  <pt-w-help (click)='$event.stopPropagation(); $event.stopImmediatePropagation()'
                                  [help]='c.help'></pt-w-help>
                </div>

                <div class="w-100" *ngIf="!editMode" style="margin-left: 5px;" >
                  <pt-icon *ngIf="c.checked" class="widget-icon-preview-color me-1" [key]='IconCheckFilled'></pt-icon>
                  <label class="form-check-label" for="{{c.uuid}}">
                    {{ c.label }}
                  </label>
                  <pt-w-help (click)='$event.stopPropagation(); $event.stopImmediatePropagation()'
                                  [help]='c.help'></pt-w-help>
                </div>
              </ng-template>



<!--              <button ngbAccordionButton class="btn btn-link p-0" *ngIf="hasChildren(c.parentId)"-->
<!--                      style="width: 35px;"></button>-->
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <ng-container *ngFor="let row of childrenData">
                    <div class="children-container" *ngIf="row.parentField === c.parentId">
                      <div class="children-title">
                        <pt-w-measure-category-type-badge
                          [type]="row.type"
                          [typeLabel]="row.typeLabel">
                        </pt-w-measure-category-type-badge>

                        {{ row.idCheck }}

                        <span *ngIf='row.normativeReference'
                              class='badge rounded-pill badge-light ms-2 normative'>
                          {{ row.normativeReference }}
                        </span>

                        <span *ngIf='row.checkValue' class='badge rounded-pill badge-light ms-2 checkValue'>
                          {{ row.checkValue }}
                        </span>
                      </div>
                      <div class="children-description">
                        {{ row.description }}
                      </div>
                    </div>
                  </ng-container>
                </ng-template>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>

  `,
  styles: [`
    .children-container {
      margin-bottom: 15px;
    }

    .children-container .children-title {
      font-weight: bold;
      margin-bottom: 5px;
      display: flex;
      align-items: baseline;
    }

    .children-container .children-description {
      color: #333333;
    }

    .custom-header::after {
      content: none;
    }

    .accordion-item .accordion-button {

      box-shadow: none;
    }

    .normative {
      border: 1px solid #333333;
      color: #333333;
    }


    .checkValue {
      border: 1px solid orange;
      color: #333333;
    }
  `],
  encapsulation: ViewEncapsulation.None,

})
export class WidgetCheckboxV0EditChildrenComponent implements OnChanges {
  @Input() checkbox: WidgetCheckboxV0NodeDto[];
  @Input() childrenData: WidgetCheckboxV0ChildrenDto[];
  @Input() editMode = true;
  @Output() changeValue = new EventEmitter<string[]>();
  IconCheckFilled = IoniconsFilled.checkbox;
  public copiedCheckBox: WidgetCheckboxV0NodeDto[] = [];

  ngOnChanges(): void {
    if (this.checkbox) {
      this.copiedCheckBox = JSON.parse(JSON.stringify(this.checkbox));
    } else {
      this.copiedCheckBox = [];
    }
  }

  checkboxChangeValue($event: boolean, row: WidgetCheckboxV0NodeDto) {
    const actualSelectedCheckbox: string[] = [];
    this.copiedCheckBox?.forEach((parent) => {
      parent.children?.forEach((children) => {
        if (children.checked) {
          actualSelectedCheckbox.push(children.uuid);
        }
      })
    })
    this.changeValue.emit(actualSelectedCheckbox);
  }

  hasChildren(parentId: number): boolean {
    return this.childrenData?.filter(cc => cc.parentField === parentId).length > 0;
  }
}


